var _excluded = ["children", "dismissOnBackdropClick", "firstFocusableElement", "isOpen", "onCancel", "visibleBackdrop"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { MODAL_BODY_CLASSNAME, MODAL_BODY_ID } from "./ModalBody.js";
import { MODAL_FOOTER_CLASSNAME } from "./ModalFooter.js";
import { MODAL_HEADER_CLASSNAME, MODAL_HEADER_ID } from "./ModalHeader.js";
import { Backdrop, Wrapper } from "./styledComponents.js";
import { closeOnEscape, returnFocusToActivator, setFocus, trapFocus } from "./utils.js";
var modalClassNames = {
  body: MODAL_BODY_CLASSNAME,
  footer: MODAL_FOOTER_CLASSNAME,
  header: MODAL_HEADER_CLASSNAME
};
var StyledContainer = styled(motion.div).withConfig({
  componentId: "CL__sc-1orbdlh-0"
})(["position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:608px;overflow:auto;max-height:calc(100% - var(--spacing-2));max-width:calc(100% - var(--spacing-2));padding:var(--spacing-5) var(--spacing-6) var(--spacing-7);background-color:var(--modal-bkg-color);border-radius:var(--border-radius-large);box-shadow:var(--box-shadow-small);"]);
var Modal = _ref => {
  var {
      children,
      dismissOnBackdropClick = true,
      firstFocusableElement,
      isOpen,
      onCancel,
      visibleBackdrop = true
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var modalRef = useRef(null);
  var [activator, setActivator] = useState(null);
  useEffect(() => {
    if (!isOpen) {
      returnFocusToActivator(activator);
      return;
    }
    setActivator(document.activeElement);
    setFocus(modalRef, modalClassNames, firstFocusableElement);
    var eventHandlers = event => {
      trapFocus(event, modalRef);
      closeOnEscape(event, onCancel);
    };
    window.addEventListener('keydown', eventHandlers);
    return () => {
      window.removeEventListener('keydown', eventHandlers);
    };
  }, [isOpen]);
  return /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(AnimatePresence, null, isOpen && /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Backdrop, {
    key: "backdrop",
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 'var(--modal-backdrop-opacity)'
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.3,
      ease: 'easeIn'
    },
    "data-visible": visibleBackdrop,
    onClick: dismissOnBackdropClick ? onCancel : undefined
  }), /*#__PURE__*/React.createElement(StyledContainer, _extends({
    key: "modal-container",
    initial: {
      x: '-50%',
      y: '-45%',
      opacity: 0
    },
    animate: {
      x: '-50%',
      y: '-50%',
      opacity: 1
    },
    exit: {
      x: '-50%',
      y: '-45%',
      opacity: 0
    },
    transition: {
      duration: 0.3,
      ease: 'easeIn'
    },
    ref: modalRef,
    "aria-labelledby": MODAL_HEADER_ID,
    "aria-describedby": MODAL_BODY_ID,
    "aria-modal": "true",
    role: "dialog"
  }, props), children))), document.body);
};
export default Modal;